import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import TextField from '../../components/common/TextField';
import Button from '../../components/common/Button';
import Typography from '../../components/common/Typography';
import { getLoginCheck } from './loginSlice';
import { getAlertMessageFunction } from '../../common/Util';

const IdLogin = ({ time }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('login');

  const [form, setForm] = useState({
    htmComCd: '',
    htmComId: '',
    htmComPass: '',
  });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const alertMessage = getAlertMessageFunction();
    const { htmComCd, htmComId, htmComPass } = form;

    if (!htmComCd) {
      alertMessage('회사 아이디를 입력해주세요.');
      return;
    }
    if (!htmComId) {
      alertMessage('사용자 아이디를 입력해주세요.');
      return;
    }
    if (!htmComPass) {
      alertMessage('비밀번호를 입력해주세요.');
      return;
    }
    console.log(form);
    dispatch(getLoginCheck(form));
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '10px' }}>
      <TextField
        placeholder={t('companyId')}
        variant="login"
        size="large"
        name="htmComCd"
        onChange={handleChange}
      />
      <TextField
        placeholder={t('userId')}
        variant="login"
        size="large"
        maxWidth="155px"
        style={{ flex: 1 }}
        name="htmComId"
        onChange={handleChange}
      />
      <TextField
        placeholder={t('password')}
        variant="login"
        size="large"
        type="password"
        name="htmComPass"
        onChange={handleChange}
      />
      <Typography
        variant="captionMedium"
        textAlign="right"
        onClick={() => navigate('/findPassword')}>
        {t('forgotPassword')}
      </Typography>
      <Button size="large" value={t('loginButton')} onClick={handleSubmit} />
      <div className="displayFlex" style={{ gap: '20px' }}>
        <span className="login_divider"></span>
        <Typography variant="body2Medium" style={{ whiteSpace: 'nowrap' }}>
          {t('or')}
        </Typography>
        <span className="login_divider"></span>
      </div>
      <Button 
        size="large" 
        color="secondary" 
        value={t('ssoButton')} 
        onClick={() => navigate('/ssoLogin')} 
      />
    </div>
  );
};

export default IdLogin;
